import { ElementRef, TemplateRef } from '@angular/core';

export enum TemplateObjectType {
    menu = 'menu',
}

export type TemplateMenuObject<TemplateData extends {}> = {
    templateRef: TemplateRef<TemplateData>;
    type: TemplateObjectType;
    templateData?: TemplateData;
    /** Date time in number */
    identifier: number;
    triggerHost: ElementRef<HTMLElement>;
};

export type TemplateObject<TemplateData extends {} = any> =
    TemplateMenuObject<TemplateData>;

export type PopupMenuData<TemplateData extends {}> = Pick<
    TemplateMenuObject<TemplateData>,
    'templateRef' | 'templateData'
>;
